
import { css } from 'lit';
export default css`
pc-link{
  --link-border-color:var(--purple-indigo);
  --link-border-width:2px;

  --link-color:var(--purple-indigo);
  --link-font-weight:var(--fw-medium);
  --link-lg-font-weight:var(--fw-normal);
}

pc-link[context="news-card"]{
  --link-font-weight:var(--fw-normal);
}

.link{
  display:inline-flex;
  align-items:center;
  gap:var(--spacing-2);
  cursor:pointer;

  font-weight:var(--link-font-weight);
  font-family:var(--ff-body);
  text-decoration:none;
}

.link--icon-right,
.link--icon-left,
.link--swipe-arrow,
.link--default,
.link--breadcrumb,
.link--nav{
  --link-border-image:linear-gradient(
    transparent calc(100% - var(--link-border-width)),
    var(--link-border-color) var(--link-border-width)
  );
  transition:background-size 0.3s;
  background-image:var(--link-border-image);
  background-size:0 100%;
  background-repeat:no-repeat;
  padding-bottom:var(--spacing-1);
  color:var(--link-color);
}

.link--swipe-arrow:hover,
.link--swipe-arrow:focus,
.link--default:hover,
.link--breadcrumb:hover,
.link--nav:hover,
.link--default:focus,
.link--breadcrumb:focus,
.link--nav:focus{
  background-size:100% 100%;
  color:var(--primary-eggplant);
}

.link--icon-right:hover,
.link--icon-right:focus,
.link--icon-left:hover,
.link--icon-left:focus{
  background-size:calc(100% - 24px) 100%;
}

.link--icon-left{
  background-position-x:24px;
}

.link--nav.link--icon-right:hover,
.link--nav.link--icon-right:focus,
.link--nav.link--icon-left:hover,
.link--nav.link--icon-left:focus{
  background-size:calc(100% - 16px) 100%;
}

.link--nav.link--icon-left{
  background-position-x:16px;
}

.link.link--breadcrumb{
  font-size:var(--fs-eyebrow-mobile);
  line-height:var(--lh-eyebrow-mobile);
  letter-spacing:var(--ls-eyebrow);
  text-transform:uppercase;
}

.link--breadcrumb.link--icon-left{
  background-position-x:20px;
}

.link--breadcrumb.link--icon-left:hover,
.link--breadcrumb.link--icon-left:focus{
  background-size:calc(100% - 20px) 100%;
}

.link--nav{
  --link-font-weight:var(--fw-normal);

  display:inline;
  color:var(--neutral-charcoal);
}

.link--nav pc-icon{
  color:var(--purple-indigo);
}

.link.link--is-reversed{
  --link-border-color:var(--primary-white);
}

.link.link--is-reversed,
.link.link--is-reversed:hover{
  color:var(--primary-white);
}

.link.link--is-reversed pc-icon{
  color:var(--purple-indigo-light);
}

.link.link--icon pc-icon{
  color:var(--neutral-charcoal);
}

.link.link--icon.link--is-reversed pc-icon,
.link.link--icon.link--is-reversed:hover pc-icon,
.link.link--icon.link--is-reversed:focus pc-icon{
  color:var(--purple-white);
}

.link.link--footer{
  --link-font-weight:var(--fw-normal);

  color:var(--purple-indigo);
  font-size:var(--fs-2xl);
  line-height:var(--lh-h3);
  font-family:var(--ff-body);
}

.link.link--footer:hover{
    background:none;
  }

.link.link--footer:hover pc-icon{
      display:inline;
      transition:all 0.3s ease 0s;
      margin:0.5rem;
    }

.link.link--tab{
  color:var(--neutral-medium-gray);
  margin-left:var(--spacing-6);
}

pc-link[active] .link.link--tab{
  background-size:100% 100%;
  color:var(--purple-indigo);
}

.link--size-base{
  font-size:var(--fs-body-mobile);
  line-height:var(--lh-body-mobile);
}

.link--size-sm{
  font-size:var(--fs-caption-mobile);
  line-height:var(--lh-caption-mobile);
}

.link--size-lg{
  --link-font-weight:var(--link-lg-font-weight);

  font-size:var(--fs-h5-mobile);
  line-height:var(--lh-h5);
}

@media (max-width: 640px){
  .link--size-lg.link--icon-right:focus,
  .link--size-lg.link--icon-right:hover{
    background-size:0;
  }
}

.link--swipe-arrow{
  color:var(--purple-indigo);
}

.link--swipe-arrow pc-icon{
    transition:all 0.3s ease 0s;
    display:inline-flex;
  }

.link--swipe-arrow:hover{
    color:var(--purple-indigo);
  }

.link--swipe-arrow:hover pc-icon{
      transform:translateX(var(--spacing-1));
    }

.link--overlay:after{
  position:absolute;
  inset:0;
  content:'';
}

@media (min-width: 992px){
  .link.link--footer{
    font-size:var(--fs-h4);
  }

  .link.link--breadcrumb{
    font-size:var(--fs-eyebrow);
    line-height:var(--lh-eyebrow);
  }

  .link--breadcrumb.link--icon-left{
    background-position-x:24px;
  }

  .link--breadcrumb.link--icon-left:hover,
  .link--breadcrumb.link--icon-left:focus{
    background-size:calc(100% - 24px) 100%;
  }

  .link--size-base{
    font-size:var(--fs-body);
    line-height:var(--lh-body);
  }

  .link--size-sm{
    font-size:var(--fs-caption);
    line-height:var(--lh-caption);
  }

  .link--size-lg{
    font-size:var(--fs-h5);
  }
}
`;